import { useStammdatenRepository } from '@Hooks/useRepository';
import { type ApiAddress, type ApiImportExternalErpAddressRequest } from '@Model';
import { ExternalErpAddressesRepository } from '@Repositories/Stammdaten';
import { useMutation } from '@tanstack/react-query';
import { type ListRequest, unwrapOr } from '@synqo/frontend-component-library';
import { useCallback } from 'react';
import { emptyPage } from '@Hooks/useListApi';
import { withExternalIdsAsIds } from './withExternalIdsAsIds';

export function useImportExternalAddress() {
    const externalAddresses = useStammdatenRepository(ExternalErpAddressesRepository);

    const loadAddresses = useCallback(
        async (listRequest: ListRequest) =>
            withExternalIdsAsIds(
                unwrapOr(await externalAddresses.getImportableAddressesPost(listRequest), emptyPage<ApiAddress>()),
            ),
        [externalAddresses],
    );

    const { mutateAsync: importAsync, isPending: isImporting } = useMutation({
        mutationFn: (request: ApiImportExternalErpAddressRequest) =>
            externalAddresses.importAddressWithContacts(request),
    });

    return {
        loadAddresses,
        isImporting,
        importAsync,
    };
}
